import { CartItem } from 'types/cart';

const renewablePlan = 'tmu_us_2026';
const nonRenewablePlan = 'tmu_us_2026_no_renew';
const certificationsOnlyPlan = 'tmu_us_2026_certifications_only';

export const getPlan = (itemsInCart: CartItem[] | undefined, autoRenew: boolean) => {
  if (itemsInCart?.some((item) => item.id === 'premium')) {
    return autoRenew ? renewablePlan : nonRenewablePlan;
  } else {
    return certificationsOnlyPlan;
  }
};
